<template>
    <v-container class="titleArea" fluid>
        <div class="logo"><img src="@/assets/logo.png" alt="ÜSKÜDAR ÜNİVERSİTESİ 2019 YKS SONUÇLARI DEĞERLENDİRME TABLOSU"/></div>
        <div class="display-1 font-weight-bold">
            ÜSKÜDAR ÜNİVERSİTESİ<br/>2019 YKS SONUÇLARI DEĞERLENDİRME TABLOSU
        </div>
    </v-container>
</template>

<script>
    export default {
        name: "AppHeader"
    }
</script>

<style>
    .titleArea {
        text-align: center;
        margin: 35px 0;
    }
    .logo {
        margin-bottom: 15px;
    }
    .logo img {
        width: 150px;
    }
</style>